import { unique } from '@vestigas/utils';

const getBulkEntityDetails = (entityId: string, bulkData: any[] = []) => {
  return bulkData.find(({ id }) => id === entityId);
};

export const selectDeliveryNotesData = (data) => {
  const mappedData = {
    ...data,
    assets: data?.assets?.map((asset) => {
      return {
        buyer:
          asset?.assetState?.body?.transaction?.agreement?.buyer
            ?.legalOrganization?.name,
        buyerCustomerNumber:
          asset?.assetState?.body?.transaction?.settlement?.salesAccount?.id,
        buyerOrderReferences: unique(
          asset?.assetState?.body?.transaction?.logisticsPackage?.[0]?.lineItem?.map(
            (item) => item?.agreement?.buyerOrder,
          ) ?? [],
        ).filter(Boolean),
        carrier:
          asset?.assetState?.body?.transaction?.delivery?.shipFrom?.consignment
            ?.carrier?.legalOrganization?.name,
        carrierId:
          asset?.assetState?.body?.transaction?.delivery?.shipFrom?.consignment
            ?.carrier?.legalOrganization?.issuerAssignedId,
        carrierLicensePlates: unique(
          asset?.assetState?.body?.transaction?.delivery?.shipFrom?.consignment?.movement?.registrationId?.map(
            ({ id }) => id,
          ) ?? [],
        ).filter(Boolean),
        constructionComponents: unique(
          asset?.assetState?.body?.transaction?.logisticsPackage?.[0]?.lineItem?.map(
            (item) => item?.product?.constructionComponent,
          ) ?? [],
        ).filter(Boolean),
        constructionPlans: unique(
          asset?.assetState?.body?.transaction?.logisticsPackage?.[0]?.lineItem?.map(
            (item) => item?.product?.constructionPlan,
          ) ?? [],
        ).filter(Boolean),
        costCenters: unique(
          asset?.assetState?.body?.transaction?.logisticsPackage?.[0]?.lineItem?.map(
            (item) => item?.settlement?.payableAccount?.name,
          ) ?? [],
        ).filter(Boolean),
        createdOn: asset?.createdOn,
        deliveryNoteDate: asset?.assetState?.body?.header?.date,
        deliveryNoteNumber: asset?.assetState?.body?.header?.id,
        deliveryType:
          asset?.assetState?.body?.transaction?.agreement?.deliveryTerms?.code,
        dlnAcceptState: asset?.dlnAcceptState,
        fromSiteIssuerAssignedId:
          asset?.assetState?.body?.transaction?.delivery?.shipFrom?.tradeAddress
            ?.issuerAssignedId,
        fromSiteName:
          asset?.assetState?.body?.transaction?.delivery?.shipFrom?.tradeAddress
            ?.lineOne,
        id: asset?.id,
        isReparsed: asset?.meta?.isReparsed,
        modifiedOn: asset?.modifiedOn,
        movementMeans:
          asset?.assetState?.body?.transaction?.delivery?.shipFrom?.consignment
            ?.movement?.means,
        permittedCostCenters: unique(
          asset?.sgw
            ?.filter(({ type }) => type === 'cc')
            ?.map(({ typeId }) => {
              return getBulkEntityDetails(typeId, data?.bulkCostCenters);
            }) ?? [],
        ).filter(Boolean),
        permittedToSites: unique(
          asset?.sgw
            ?.filter(({ type }) => type === 'pr')
            ?.map(({ typeId }) => {
              return getBulkEntityDetails(typeId, data?.bulkSites);
            }) ?? [],
        ).filter(Boolean),
        processState: asset?.processState,
        project:
          asset?.assetState?.body?.transaction?.delivery?.shipTo?.tradeAddress
            ?.issuerAssignedId,
        recipient:
          asset?.assetState?.body?.transaction?.delivery?.shipTo
            ?.legalOrganization?.name,
        reparsingModelId: asset?.meta?.modelId,
        seller:
          asset?.assetState?.body?.transaction?.agreement?.seller
            ?.legalOrganization?.name,
        sellerOrderReferences: unique(
          asset?.assetState?.body?.transaction?.logisticsPackage?.[0]?.lineItem?.map(
            (item) => item?.agreement?.sellerOrder,
          ) ?? [],
        ).filter(Boolean),
        source: asset?.meta?.source,
        supplier:
          asset?.assetState?.body?.transaction?.delivery?.shipFrom
            ?.legalOrganization?.name,
        toSiteRecipient:
          asset?.assetState?.body?.transaction?.logisticsPackage?.[0]
            ?.lineItem?.[0]?.settlement?.purchaseAccount?.id,
        toSiteSupplierAddress:
          asset?.assetState?.body?.transaction?.delivery?.shipTo?.tradeAddress,
        toSiteSupplierName:
          asset?.assetState?.body?.transaction?.delivery?.shipTo?.tradeAddress
            ?.lineOne,
        trader:
          asset?.assetState?.body?.transaction?.agreement?.trader
            ?.legalOrganization?.name,
      };
    }),
  };

  return mappedData;
};
